function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { withMedia } from 'react-media-query-hoc';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { AverageStarRatingAndTotal } from '@domain-group/fe-co-allhomes-average-star-rating-and-total';
import { AgentEnquiryForm } from '@domain-group/fe-co-allhomes-enquiry-form';
import StatsButtons from './stats-buttons';
import useSafariModalWorkaround from './use-safari-modal-workaround';
import * as styles from './agency-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AgencyCard = _ref => {
  var _address$division, _address$state;
  var index = _ref.index,
    enquiryEndpoint = _ref.enquiryEndpoint,
    results = _ref.results,
    onAppraisalClick = _ref.onAppraisalClick,
    appraisalAddress = _ref.appraisalAddress,
    _ref$safariModalWorka = _ref.safariModalWorkaroundEnabled,
    safariModalWorkaroundEnabled = _ref$safariModalWorka === void 0 ? false : _ref$safariModalWorka,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'vertical' : _ref$appearance,
    emailButtonLabel = _ref.emailButtonLabel,
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? {
      desktop: false
    } : _ref$media,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick;
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    emailEnquiryModalOpen = _useState2[0],
    setEmailEnquiryModalOpen = _useState2[1];
  var agencies = results.nodes;
  var agencyNode = agencies[index];
  var agency = agencyNode.agency,
    stats = agencyNode.stats;
  var agencyId = agency.agencyId,
    images = agency.images,
    name = agency.name,
    address = agency.address,
    isEmailContactable = agency.isEmailContactable,
    phone = agency.phone,
    profileUrl = agency.profileUrl,
    reviewProfile = agency.reviewProfile,
    inclusions = agency.inclusions,
    logoBackgroundColour = agency.logoBackgroundColour;
  var isPlatinum = (inclusions === null || inclusions === void 0 ? void 0 : inclusions.brandingLevel) === 'PLATINUM';
  var handleAppraisalClick = () => {
    setEmailEnquiryModalOpen(true);
    onAppraisalClick();
  };
  useSafariModalWorkaround(emailEnquiryModalOpen, safariModalWorkaroundEnabled && Boolean(!(media !== null && media !== void 0 && media.desktop)));
  return ___EmotionJSX(EventBoundary, {
    data: {
      agencyId,
      agency: name
    }
  }, ___EmotionJSX("div", {
    css: styles.agencyCard(appearance)
  }, ___EmotionJSX("div", {
    css: styles.banner(isPlatinum, logoBackgroundColour || '')
  }, ___EmotionJSX("img", {
    css: styles.logo(isPlatinum),
    src: (images === null || images === void 0 ? void 0 : images.tinyLogo) || '',
    alt: ""
  })), ___EmotionJSX("div", {
    css: styles.content(appearance)
  }, ___EmotionJSX("div", {
    css: styles.profile
  }, ___EmotionJSX("div", {
    css: styles.nameDetail
  }, ___EmotionJSX("a", {
    css: styles.name,
    href: profileUrl || undefined,
    onClick: onClick
  }, name), address && ___EmotionJSX("div", {
    css: styles.address
  }, ___EmotionJSX("span", null, "".concat(address.line1, ",")), ___EmotionJSX("span", null, " ".concat((_address$division = address.division) === null || _address$division === void 0 ? void 0 : _address$division.name, ", ").concat((_address$state = address.state) === null || _address$state === void 0 ? void 0 : _address$state.abbreviation, " ").concat(address.postcode)))), toggledFeatures[ToggledFeatureKey.FIND_AN_AGENT_PACKAGE_BRANDING] && !!(reviewProfile !== null && reviewProfile !== void 0 && reviewProfile.reviewCount) && reviewProfile.reviewCount > 0 && ___EmotionJSX(AverageStarRatingAndTotal, {
    size: "xs",
    averageRating: reviewProfile.overallRating,
    totalReviews: reviewProfile.reviewCount
  })), ___EmotionJSX(StatsButtons, {
    stats: stats,
    emailContactable: isEmailContactable,
    phone: phone,
    onAppraisalClick: handleAppraisalClick,
    appearance: appearance,
    emailButtonLabel: emailButtonLabel,
    consumer: "agency"
  }))), emailEnquiryModalOpen && ___EmotionJSX(AgentEnquiryForm, {
    endpointUrl: enquiryEndpoint,
    closeCallback: () => setEmailEnquiryModalOpen(false),
    formTitle: "Request a free appraisal",
    clientType: "AGENCY",
    agencies: agencies,
    appearance: "appraisal",
    listingAddress: appraisalAddress
  }));
};
export default withMedia(AgencyCard);